"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_PATIENT_RELATIONSHIPS = void 0;
const Filters_1 = require("./Filters");
exports.VALID_PATIENT_RELATIONSHIPS = [Filters_1.NEW_PATIENT, Filters_1.ESTABLISHED_PATIENT];
//# sourceMappingURL=deepLinking.js.map